/* jshint esversion: 6 */
import React from 'react';
import Toggle from 'app/components/common/ToggleControl.jsx';
import HelpButton from 'app/components/common/HelpButton.jsx';

class ShortenerDetailDefault extends React.Component {
    render() {
        let panelContent = null,
            constants = this.props.app.config.constants,
            defaultToggle = false;

        if (parseInt(this.props.user.detail.defaultSaId, 10) === parseInt(this.props.data.id, 10)) {
            defaultToggle = true;
        } else if (parseInt(this.props.data.default, 10) === 1) {
            defaultToggle = true;
        }

        let activeLabel = "Use this as the default when sharing manually or setting up new automated sharing.",
            inactiveLabel = "Use this as the default when sharing manually or setting up new automated sharing.";

        if (this.props.user.detail.routeViewType === constants.ROUTE_VIEW_SIMPLE) {
            activeLabel = inactiveLabel = "Use this as the default when sharing manually or the default shortener for new socials.";
        }

        return (
            <div className="editor-panel">
                <fieldset>
                    <legend>Default</legend>
                    <Toggle
                        active={defaultToggle}
                        callback={this.props.updateSystemDefault}
                        linkedField="data.default"
                        activeLabel={activeLabel}
                        inactiveLabel={inactiveLabel}
                        labelPlacement="right"
                        labelClass="form-inline-label light" />
                </fieldset>
                {this.props.getApplyButtons()}
            </div>
        );
    }

};

export default ShortenerDetailDefault;
